<!-- value.control.component.html!-->
<ng-container *ngIf="valueCtrl">
    <boolean-component class="col-x" *ngIf="valueCtrl.type == 'boolean'" [(ngModel)]="value" name="valueBoolean"
        placeholder="{{ valueCtrl.caption| translate}}" [showHelpPoint]="valueCtrl.showHelpPoint"
        helpresource="{{valueCtrl.helpResource | translate}}" [readonly]="readonly"
        (valueChanged)="onValueChanged($event)">
    </boolean-component>

    <tristate class="col-20" *ngIf="valueCtrl.type == 'HTriState'" [(ngModel)]="value" name="valueTriState"
        placeholder="{{ valueCtrl.caption| translate}}" [readonly]="readonly">
    </tristate>

    <input-component class="col-20" *ngIf="valueCtrl.type == 'Long'" [(ngModel)]="value" name="valueLong"
        placeholder="{{ valueCtrl.caption| translate}}" [step]="1" type="number" autocomplete="off"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)">
    </input-component>

    <input-component class="col-20" *ngIf="valueCtrl.type == 'Integer'" [(ngModel)]="value" name="valueInteger"
        placeholder="{{ valueCtrl.caption| translate}}" [step]="1" type="number" autocomplete="off"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)">
    </input-component>

    <input-component class="col-20" *ngIf="valueCtrl.type == 'Double'" [(ngModel)]="value" name="valueDouble"
        placeholder="{{ valueCtrl.caption| translate}}" [step]="0.1" type="number" autocomplete="off"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)">
    </input-component>

    <textarea-component class="col-x" *ngIf="valueCtrl.type == 'string'" [(ngModel)]="value" name="valueString"
        placeholder="{{ valueCtrl.caption| translate}}" (valueChanged)="onValueChanged($event)"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}">
    </textarea-component>

    <enum-selector class="col-x" *ngIf="valueCtrl.type == 'Enum'" [(ngModel)]="value" [readonly]="readonly"
        [enumvalues]="valueCtrl.enumValues" placeholder="{{ valueCtrl.caption| translate}}"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}" name="valueEnum"
        [translategroup]="valueCtrl.enumTranslateGroup" [showclosebutton]="false"
        (valuechangefunction)="onValueChanged($event)">
    </enum-selector>

    <date-picker class="col-20" *ngIf="valueCtrl.type == 'HDate'" [(ngModel)]="value"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)" name="valueHDate"
        placeholder="{{ valueCtrl.caption| translate}}">
    </date-picker>

    <tags-chips class="col-x" *ngIf="valueCtrl.type == 'HTags'" [showHelpPoint]="valueCtrl.showHelpPoint"
        helpresource="{{valueCtrl.helpResource | translate}}" [readonly]="readonly" [(ngModel)]="value"
        (valueChanged)="onValueChanged($event)" name="valueHTags" placeholder="{{ valueCtrl.caption| translate}}">
    </tags-chips>

    <time-picker class="col-20" *ngIf="valueCtrl.type == 'HTime'" [(ngModel)]="value"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)" name="valueHTime"
        placeholder="{{ valueCtrl.caption| translate}}">
    </time-picker>

    <hour-picker class="col-20" *ngIf="valueCtrl.type == 'HHour'" [(ngModel)]="value"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)" name="valueHHour"
        placeholder="{{ valueCtrl.caption| translate}}">
    </hour-picker>

    <hourinterval-picker class="col-20" *ngIf="valueCtrl.type == 'HHourInterval'" [(ngModel)]="value"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)" name="valueHHourInterval"
        placeholder="{{ valueCtrl.caption| translate}}">
    </hourinterval-picker>

    <hourintervals-picker class="col-40" *ngIf="valueCtrl.type == 'HHourIntervals'" [(ngModel)]="value"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly" (valueChanged)="onValueChanged($event)" placeholder="{{ valueCtrl.caption| translate}}"
        name="valueHHourIntervals">
    </hourintervals-picker>

    <color-picker class="backgroundColor" *ngIf="valueCtrl.type == 'HColor'" [(ngModel)]="value"
        placeholder="{{ valueCtrl.caption| translate}}" name="backgroundColor" (valueChanged)="onValueChanged($event)"
        [showHelpPoint]="valueCtrl.showHelpPoint" helpresource="{{valueCtrl.helpResource | translate}}"
        [readonly]="readonly">
    </color-picker>

</ng-container>